import React, { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';

export const SearchBar = ({ placeholder = null, title = null, expanded, setExpanded = () => {}, setSearchQuery, autofocus = false, value = '', ariaLabel = placeholder || 'Search' }) => {
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const hasMountedRef = useRef(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (expanded) {
      if (!hasMountedRef.current) {
        if (autofocus) {
          inputRef.current?.focus();
        }
      } else {
        inputRef.current?.focus();
      }
    }
    hasMountedRef.current = true;
  }, [expanded, autofocus]);

  // Update input value when controlled value changes
  useEffect(() => {
    if (inputRef.current && value !== undefined) {
      inputRef.current.value = value;
    }
  }, [value]);

  const handleClearSearch = (e) => {
    e.stopPropagation();
    setSearchQuery('');
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  if (title) {
    return (
      <div className='searchbar'>
        {title && <label className="search-title subtext">{title}</label>}
        <div
          ref={containerRef}
          className={`search-container ${expanded ? "expanded" : ""} ${isFocused ? "focused" : ""}`}
          style={!expanded ? { justifyContent: "center" } : { padding: "0 10px" }}
          onClick={() => setExpanded(true)}
        >
          <Search className="search-icon" size={expanded ? "20" : "25"} />
          <input
            ref={inputRef}
            type="search"
            name="site_search_query"
            placeholder={placeholder || "Search"}
            aria-label={ariaLabel}
            className="search-input"
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            style={{ display: expanded ? "block" : "none" }}
            autoComplete="off"
            data-1p-ignore="true"
            data-bwignore="true"
            data-form-type="other"
            data-lpignore="true"
            enterKeyHint="search"
          />
          {inputRef?.current?.value?.length != 0 && <X
            className="clear-icon"
            size={expanded ? "20" : "25"}
            onClick={handleClearSearch}
            style={{ display: expanded ? "block" : "none" }}
          />}
        </div>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className={`search-container ${expanded ? "expanded" : ""} ${isFocused ? "focused" : ""}`}
      style={!expanded ? { justifyContent: "center" } : { padding: "0 10px" }}
      onClick={() => setExpanded(true)}
    >
      <Search className="search-icon" size={expanded ? "20" : "25"} />
      <input
        ref={inputRef}
        type="search"
        name="site_search_query"
        placeholder={placeholder || "Search"}
        aria-label={ariaLabel}
        className="search-input"
        onChange={(e) => setSearchQuery(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{ display: expanded ? "block" : "none" }}
        autoComplete="off"
        data-1p-ignore="true"
        data-bwignore="true"
        data-form-type="other"
        data-lpignore="true"
        enterKeyHint="search"
      />
      {inputRef?.current?.value?.length != 0 && <X
        className="clear-icon"
        size={expanded ? "20" : "25"}
        onClick={handleClearSearch}
        style={{ display: expanded ? "block" : "none" }}
      />}
    </div>
  );
};

export default SearchBar;
